<!--The content below is only a placeholder and can be replaced.-->
<nav class="vd-card navbar navbar-expand-lg">
    <div class="container">

        <a class="navbar-brand vd-brand" [routerLink]="['/']">
            <span class="brand-bold-part">Grund</span><span>Risk</span><i class="fa fa-tint"></i><br /><span
                class="vd-text-sm-muted">Danmarks Miljøportal</span>
        </a>
        <span class="vd-text-sm-muted text-nowrap">
            {{ version }} - {{ buildDate }}
        </span>

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                </li>
            </ul>
            <div class="nav-item">
                <a class="nav-link" target="_blank"
                    href="https://danmarksmiljoeportal.zendesk.com/hc/da/sections/360002363858-GrundRisk">
                    <i class="fa fa-question-circle"></i> Hjælp
                </a>
            </div>
            <div class="nav-item">
                <a class="nav-link" (click)="logout()"><i class="fa fa-sign-out"></i> Log ud</a>
            </div>
        </div>

    </div>
</nav>

<div>
    <router-outlet></router-outlet>
</div>
<iframe id="fLogout" #fLogout style="position: absolute;top:-1px;left:-11px; width:1px;height:1px"></iframe>